import React from "react";
import "./MaintenancePage.css";

function MaintenancePage() {
  return (
    <div className="maintenance-page">
      <div className="maintenance-card">
        <h1>Coming Soon</h1>
        <p>Online sponsorship bookings are temporarily paused for scheduled maintenance.</p>
        <p>We'll be back shortly. Thank you for your patience and continued support.</p>
        <div className="maintenance-contact">
          Questions? <a href="mailto:info@suwaarana.org">info@suwaarana.org</a>
        </div>
      </div>
    </div>
  );
}

export default MaintenancePage;
